
export default {
  props: {
    fill: { type: String, default: "none" },
    stroke: { type: String, default: "#333" },
  },
};
